/* ==========================================================
   CADEAU AUTOMATIQUE — Shanty Biscuits
   Ajoute le produit cadeau (1 exemplaire) quand le panier atteint
   le seuil, le retire en dessous. Le prix à 0 € est appliqué par la
   remise automatique Shopify.
   Config : window.ShantyGiftConfig (snippets/gift-auto.liquid).
   API : window.ShantyGift.sync() -> Promise<boolean> (true si le
   panier a été modifié).
   ========================================================== */
(function () {
  'use strict';

  var C = window.ShantyGiftConfig;
  if (!C || !C.variantId) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  /* Chargé avant cart-drawer.js : fetch natif, non intercepté par le drawer */
  var nativeFetch = window.fetch.bind(window);
  var queue = Promise.resolve(false);

  function post(path, body) {
    return nativeFetch(ROOT + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Shanty-Gift': '1' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('gift ' + res.status);
      return res.json();
    });
  }

  function thresholdInCents() {
    /* Seuil réglé en € : converti si le visiteur voit une autre devise */
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    return Math.round(C.threshold * rate);
  }

  function doSync() {
    return nativeFetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var giftLines = cart.items.filter(function (i) { return i.variant_id === C.variantId; });
        var giftQty = 0, giftValue = 0;
        giftLines.forEach(function (i) { giftQty += i.quantity; giftValue += i.final_line_price; });

        /* Même base que la barre de paliers, hors cadeau */
        var base = (C.useSubtotal ? cart.items_subtotal_price : cart.total_price) - giftValue;
        var others = cart.item_count - giftQty;
        var want = C.active && others > 0 && base >= thresholdInCents();

        if (want && giftQty === 0) {
          return post('cart/add.js', { items: [{ id: C.variantId, quantity: 1 }] }).then(function () { return true; });
        }
        if (!want && giftQty > 0) {
          var off = {};
          giftLines.forEach(function (i) { off[i.key] = 0; });
          return post('cart/update.js', { updates: off }).then(function () { return true; });
        }
        if (want && giftQty > 1) {
          var one = {};
          giftLines.forEach(function (i, n) { one[i.key] = n === 0 ? 1 : 0; });
          return post('cart/update.js', { updates: one }).then(function () { return true; });
        }
        return false;
      })
      .catch(function (e) {
        /* Rupture de stock, réseau... : on ne bloque jamais le panier */
        if (window.console) console.warn('[ShantyGift]', e);
        return false;
      });
  }

  /* Les synchronisations s'enchaînent (jamais deux en parallèle) */
  function sync() {
    queue = queue.then(doSync, doSync);
    return queue;
  }

  window.ShantyGift = { sync: sync };

  /* ---------- Page panier : resync puis rechargement si besoin ---------- */
  if (C.isCartPage) {
    var reloadIfChanged = function (changed) { if (changed) window.location.reload(); };
    sync().then(reloadIfChanged);
    /* Quantités modifiées en AJAX sur la page panier */
    document.addEventListener('cart.update.react', function () { sync().then(reloadIfChanged); });
    return;
  }

  /* ---------- Autres pages : contrôle au chargement si le panier n'est pas vide ---------- */
  if (C.itemCount > 0) {
    sync().then(function (changed) {
      if (changed && window.ShantyCartDrawer) window.ShantyCartDrawer.refresh();
    });
  }
})();
